import { combineReducers } from 'redux';

import { reducer as applicationReducer } from './application/reducer';
import { reducer as appointments } from './appointment/reducer';
import { toasts } from './toasts/reducer';
import { notifications, globalNotifications } from './notification/reducer';
import { reducer as services } from './service/reducer';
import { reducer as userReducer } from './user/reducer';
import { fimlabReducer } from './fimlab/reducer';
import { questionnaireReducer } from './questionnaires/reducer';
import { reducer as hpa } from './hpa/reducer';
import { reducer as nav } from './navigation/reducer';
import { linkkipalvelu } from './linkkipalvelu/reducer';
import { biobankReducer } from './biobank/reducer';
import { reducer as userInfoReducer } from '../views/userInfo/data/reducer';
import { timelineReducer } from '../views/timeline/data/reducer';
import { sessionReducer } from "./session/reducer";
import { timelineFrameReducer } from "../views/timelineframe/data/reducer";
import { flowmedikCareConversationsReducer } from "./flowmedik/reducer";

export const APPLICATION = 'applicationReducer';
export const FIMLAB = 'fimlabReducer';
export const TIMELINE = 'timelineReducer';
export const BACKENDNOTIFICATIONS = 'notificationsReducer';
export const GLOBALNOTIFICATIONS = 'globalNotificationsReducer';
export const TOASTS = 'toastReducer';
export const QUESTIONNAIRES = 'questionnaireReducer';
export const USER = 'userReducer';
export const SERVICES = 'services';
export const APPOINTMENTS = 'appointments';
export const HPA = 'hpa';
export const NAV = 'nav';
export const LINKKIPALVELU = 'linkkipalvelu';
export const CARECONVERSATIONS = 'careConversationsReducer';
export const FLOWMEDIK_CARECONVERSATIONS = 'flowmedikCareConversationsReducer';
export const BIOBANK = 'biobankReducer';
export const USERINFO = 'userInfo';
export const SESSION = 'sessionReducer';
export const TIMELINEFRAME = 'timelineFrameReducer';

const rootReducer = combineReducers({
  [APPOINTMENTS]: appointments,
  [SERVICES]: services,
  [USER]: userReducer,
  [BACKENDNOTIFICATIONS]: notifications,
  [GLOBALNOTIFICATIONS]: globalNotifications,
  [TOASTS]: toasts,
  [TIMELINE]: timelineReducer,
  [FIMLAB]: fimlabReducer,
  [APPLICATION]: applicationReducer,
  [HPA]: hpa,
  [QUESTIONNAIRES]: questionnaireReducer,
  [LINKKIPALVELU]: linkkipalvelu,
  [NAV]: nav,
  [FLOWMEDIK_CARECONVERSATIONS]: flowmedikCareConversationsReducer,
  [BIOBANK]: biobankReducer,
  [USERINFO]: userInfoReducer,
  [SESSION]: sessionReducer,
  [TIMELINEFRAME]: timelineFrameReducer,
});

export default rootReducer;
